import { httpRequest } from "@services/http";

export class CommandStartOAuthFlow {
  async run(resourceId: number) {
    const { auth_url } = await httpRequest<{ auth_url: string }>(
      `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content_network/network_accounts/network_resources/${resourceId}/oauth/start`,
      { method: "GET", auth: true, headers: { Accept: "application/json" } }
    );

    const popup = window.open(auth_url, "oauth", "width=600,height=800");
    if (!popup) {
      alert("Please allow popups to connect your account.");
    }
  }
}